import { render } from "./journals.vue?vue&type=template&id=cc6f6398&scoped=true"
import script from "./journals.vue?vue&type=script&lang=js"
export * from "./journals.vue?vue&type=script&lang=js"

import "./journals.vue?vue&type=style&index=0&id=cc6f6398&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc6f6398"]])

export default __exports__